<template>
  <div v-if="devicesLoaded">
    <div v-if="$store.state.stats.devices.length>0 && charts.length>0" class="stats">
      <router-link
        tag="div"
        :to="'/device/' + device.uuid"
        v-for="device in $store.state.stats.devices"
        :key="device.id"
        width="100%"
        height="350"
      >
        <apexchart
          type="area"
          :ref="'chart_'+device.id"
          height="350"
          width="100%"
          :options="charts[device.id].chartOptions"
          :series="charts[device.id].series"
        ></apexchart>
      </router-link>
    </div>
    <p v-else class="no-result">No devices</p>
  </div>
  <Loading v-else />
</template>
<style lang="scss" scoped>
div.stats {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  & > * {
    margin: 1rem;
    padding: 1rem !important;
    border-radius: 7px;
    overflow: hidden;
    background-color: var(--bg-color-2);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    flex: 2 2 400px !important;
    transition: background-color 300ms ease, box-shadow 300ms ease;
    cursor: pointer;
    &:hover {
      background-color: var(--bg-color-3);
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25),
        0 10px 10px rgba(0, 0, 0, 0.22);
    }
    &>*{
      min-height: 0 !important;
    }
  }
}
</style>
<script>
import Loading from "@/components/parts/Loading.vue";

export default {
  name: "Stats",
  components: { Loading },
  data() {
    return {
      devicesLoaded: false,
      interval: null,
      charts: [],
      defaultChart: {
        series: [
          {
            name: "CPU",
            data: []
          },
          {
            name: "RAM",
            data: []
          },
          {
            name: "DISK",
            data: []
          }
        ],
        chartOptions: {
          chart: {
            type: "area",
            animations: {
              enabled: false,
              easing: "linear",
              dynamicAnimation: {
                speed: 0
              }
            },
            stacked: false,
            height: 350,
            width: "100%",
            zoom: {
              type: "x",
              enabled: false
            },
            toolbar: {
              autoSelected: "zoom"
            }
          },
          dataLabels: {
            enabled: false
          },
          markers: {
            size: 0
          },
          title: {
            text: "Unit",
            align: "left"
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.5,
              opacityTo: 0,
              stops: [0, 90, 100]
            }
          },
          yaxis: {
            labels: {
              formatter: function(val) {
                return val.toFixed(2) + " %";
              }
            },
            min: 0,
            max: 100
          },
          xaxis: {
            type: "datetime",
            min: new Date().getTime(),
            max: new Date().getTime(),
            tickInterval: 6,
            labels: {
              datetimeUTC: false,
              hideOverlappingLabels: true,
              formatter: function(val, timestamp) {
                return new Date(timestamp).toTimeString().split(" ")[0];
              }
            }
          },
          tooltip: {
            shared: true,
            y: {
              formatter: function(val) {
                return val.toFixed(2) + " %";
              }
            },
            x: {
              show: true,
              format: "HH:mm:ss",
              formatter: undefined
            }
          }
        }
      }
    };
  },
  sockets: {
    addstats(dat) {
      console.log(dat);
      var stat = JSON.parse(dat.stats);
      var vue = this;

      //CPU
      vue.charts[dat.device_id].series[0].data.push({
        x: dat.creation,
        y: stat.cpu
      });

      //MEM
      var memory =
        ((stat.memory.total - stat.memory.free) / stat.memory.total) * 100;
      vue.charts[dat.device_id].series[1].data.push({
        x: dat.creation,
        y: memory
      });

      //DISK
      var disk =
        (stat.fsSize.reduce(function(ac, cur) {
          if (isNaN(Number(cur.used))) {
            return ac;
          } else {
            return ac + Number(cur.used);
          }
        }, 0) /
          stat.fsSize.reduce(function(ac, cur) {
            if (isNaN(Number(cur.size))) {
              return ac;
            } else {
              return ac + Number(cur.size);
            }
          }, 0)) *
        100;
      vue.charts[dat.device_id].series[2].data.push({
        x: dat.creation,
        y: disk
      });
    }
  },
  methods: {
    getStats: function(device_id) {
      var vue = this;
      this.$socket.client.emit(
        "getLatestStats",
        device_id,
        (error, response) => {
          if (error == "200") {
            response.forEach(dat => {
              var reportstats = JSON.parse(dat.stats);

              vue.charts[device_id].series[0].data.push({
                x: dat.creation,
                y: reportstats.cpu
              });
              var memory =
                ((reportstats.memory.total - reportstats.memory.free) /
                  reportstats.memory.total) *
                100;
              vue.charts[device_id].series[1].data.push({
                x: dat.creation,
                y: memory
              });

              var disk =
                (reportstats.fsSize.reduce(function(ac, cur) {
                  if (isNaN(Number(cur.used))) {
                    return ac;
                  } else {
                    return ac + Number(cur.used);
                  }
                }, 0) /
                  reportstats.fsSize.reduce(function(ac, cur) {
                    if (isNaN(Number(cur.size))) {
                      return ac;
                    } else {
                      return ac + Number(cur.size);
                    }
                  }, 0)) *
                100;
              vue.charts[device_id].series[2].data.push({
                x: dat.creation,
                y: disk
              });
            });
            this.updateChart(device_id, false);
          }
        }
      );
    },
    updateChart: function(device_id, animation) {
      const yesterday = new Date();
      yesterday.setMinutes(yesterday.getMinutes() - 5);
      this.$refs["chart_" + device_id][0].updateOptions(
        {
          series: this.charts[device_id].series,
          chart: {
            animations: {
              enabled: animation,
              easing: "linear",
              dynamicAnimation: {
                speed: 5000
              }
            }
          },
          xaxis: {
            type: "datetime",
            min: yesterday.getTime(),
            max: new Date().getTime(),
            tickInterval: 6,
            labels: {
              datetimeUTC: false,
              hideOverlappingLabels: true,
              formatter: function(val, timestamp) {
                return new Date(timestamp).toTimeString().split(" ")[0];
              }
            }
          },
          yaxis: {
            labels: {
              formatter: function(val) {
                return val.toFixed(2) + " %";
              }
            },
            min: 0,
            max: 100
          }
        },
        false,
        true
      );
    },
    getDevices: function() {
      var vue = this;
      vue.$socket.client.emit("getDevices", null, (error, response) => {
        vue.$store.state.stats.devices = response;
        vue.devicesLoaded = true;
        vue.$store.state.stats.devices.forEach(device => {
          console.log("loaded " + device.id);
          vue.charts[device.id] = JSON.parse(
            JSON.stringify(Object.assign({}, vue.defaultChart))
          );
          vue.charts[device.id].chartOptions.title.text = device.name;
          vue.$nextTick(() => {
            console.log("get stats " + device.id);
            vue.getStats(device.id);
          });
        });
      });
    },
    getView: function() {
      var vue = this;
      vue.$socket.client.emit(
        "getView",
        this.$route.params.viewid,
        (error, response) => {
          vue.$store.state.stats.devices = response;
        vue.devicesLoaded = true;
          vue.$store.state.stats.devices.forEach(device => {
            console.log("loaded " + device.id);
            vue.charts[device.id] = JSON.parse(
              JSON.stringify(Object.assign({}, vue.defaultChart))
            );
            vue.charts[device.id].chartOptions.title.text = device.name;
            vue.$nextTick(() => {
              console.log("get stats " + device.id);
              vue.getStats(device.id);
            });
          });
        }
      );
    }
  },
  created() {
    if (this.$route.params.viewid) {
      this.getView();
    } else {
      this.getDevices();
    }
    var vue = this;
    this.interval = setInterval(function() {
      vue.$store.state.stats.devices.forEach(device => {
        vue.updateChart(device.id, true);
      });
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>